import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { TableContextMenuStoreContext } from '../contexts/StoreContext'
import { TableContextMenuStore } from '../store/interface'

export const useTableContextMenuStore: UseStore<
  TableContextMenuStore
> = selector => {
  return useContextStore(TableContextMenuStoreContext, selector)
}

export const useTableContextMenuStoreApi = () => {
  return useContextStoreApi(TableContextMenuStoreContext)
}
